module.exports = __webpack_public_path__ + "static/media/pagesBG.67a157ee.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ltl-ai/pagesBG.gif
// module id = 1292
// module chunks = 3